import { replaceInChain } from "@insite/client-framework/HandlerCreator";
// import { AddProductApiParameter, addProductWithResult } from "@insite/client-framework/Services/CartService";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { AddProductApiParameter, addProductWithResult } from "@MasterBluePrint/Overrides/Services/CartService";
// this will enable HMR for custom handlers
/* istanbul ignore next */
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// the chain is just an array, so it can be modified directly instead of using the helper functions
replaceInChain(chain, SendDataToApi, async props => {
    const result = await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else
    {    
        if (result.statusCode === 403)
        {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }  
        // add dispatch for set flag after complete the request
        props.dispatch({
            type: "Context/CompleteAddingProductToCart",
        });
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
});